<template>
  <div>

    <h1>Tag</h1>

    <KadoMenu />

    <template v-if="idToken">

      <!-- session info area -->
      <div class="div-session">
        <font-awesome-icon icon="user" /> : {{ username }} <span @click="signOut">[ <font-awesome-icon icon="sign-out-alt" title="sign out" /> ]</span>
      </div>
      <hr />

    </template>

    <!-- messege area -->
    <div class="div-procMsg-normal" v-if="procMsgNormal">{{ procMsgNormal }}</div>
    <div class="div-procMsg-attention" v-if="procMsgAttention">{{ procMsgAttention }}</div>

    <template v-if="idToken && localTagData.length >= 1">

      <!-- item filter area -->
      <div class="div-filter">
        <div class="div-filter-bar">
          <font-awesome-icon icon="filter" />
          <input type="text" v-model="filterWord" placeholder="filter the list below">
          <font-awesome-icon icon="times" @click="filterWord=''" />
        </div>
      </div>

      <!-- spinner animation -->
      <div class="div-container-sipnner">
        <div class="div-spinner" v-if="onTagDataLoading">Loading...</div>
      </div>

      <!-- item list area -->
      <table class="table-list">

        <colgroup>
          <col span="1" class="colgroup-col01">
          <col span="1" class="colgroup-col02">
        </colgroup>

        <!--item list header (no-shrink) -->
        <tr class="tr-head">
          <!-- valTag -->
          <th>
            <div class="div-th-col" @click="sortBy('valTag')">Tag
              <span v-if="sortArrow('valTag')==='asc'"><font-awesome-icon icon="sort-amount-up" /></span>
              <span v-else-if="sortArrow('valTag')==='desc'"><font-awesome-icon icon="sort-amount-down" /></span>
              <span v-else></span>
            </div>
          </th>
          <!-- action(button) -->
          <th>
            <div class="div-action-reload">
              <div class="div-action">Action</div>
              <div class="div-reload" @click="readTagData"><font-awesome-icon icon="redo" /></div>
            </div>
          </th>
        </tr>

        <!--item list header (shrink) -->
        <div class="div-head-onShrink">
        <tr class="tr-head-onShrink">
          <td class="td-cols-action-reload">
            <div class="div-cols-action-reload">
              <div class="div-cols-action">Cols [
                <!-- valTag -->
                <div class="div-th-col" @click="sortBy('valTag')">Tag
                  <span v-if="sortArrow('valTag')==='asc'"><font-awesome-icon icon="sort-amount-up" /></span>
                  <span v-else-if="sortArrow('valTag')==='desc'"><font-awesome-icon icon="sort-amount-down" /></span>
                  <span v-else ></span>
                </div>&nbsp;
                ] / Action
              </div>
              <div class="div-cols-reload" @click="readTagData"><font-awesome-icon icon="redo" /></div>
            </div>
          </td>
        </tr>
        </div>

        <!--item list body -->
        <tr v-for="item in localTagDataArranged" :key="item.valTag" class="tr-body">
          <!-- valTag -->
          <td class="td-prime-col">
            <div v-if="item.onUpdate">
              <input type="text" v-model="item.updateValTag" placeholder="valTag" class="inputText-common" />
            </div>
            <div v-else>
              <label>{{ item.valTag }}</label>
            </div>
          </td>
          <!-- action(button) -->
          <td class="td-sub-col">
            <template v-if="!item.onDelete && !item.onUpdate">
              <button @click="deleteTagDataStart(item)" :disabled="onUpdateDelete" class="button-normal" >delete</button>
              <button @click="updateTagDataStart(item)" :disabled="onUpdateDelete" class="button-normal" >update</button>
            </template>
            <template v-if="item.onDelete">
              <button @click="deleteTagDataCancel(item)" class="button-cancel" >cancel</button>
              <button @click="deleteTagDataFix(item)" class="button-attention" >delete!!</button>
            </template>
            <template v-if="item.onUpdate">
              <button @click="updateTagDataCancel(item)" class="button-cancel" >cancel</button>
              <button @click="updateTagDataFix(item)" class="button-normal" >update!!</button>
            </template>
          </td>
        </tr>

      </table>

    </template>

  </div>
</template>

<script>
// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// 認証モジュール
import { MyAuth } from '@/my-modules/my-auth'
// データモジュール
import { MyData } from '@/my-modules/my-data'
// コンポーネント：角メニュー
import KadoMenu from '@/components/KadoMenu.vue'

export default {
  name: 'Tag',

  components: {
    KadoMenu
  },

  data: function () {
    return {
      localTagData: [],
      onTagDataLoading: false,
      onUpdateDelete: false,
      sortKey: 'valTag',
      sortAsc: true,
      filterWord: '',
      procMsgNormal: null,
      procMsgAttention: null,
      username: '',
      idToken: ''
    }
  },

  mounted: function () {
    this.readTagData()
  },

  methods: {

    /* =================================================================================
     * signOut
     *   サインアウト
     * ============================================================================== */
    signOut () {
      mc.LOG_LEVEL ? console.log('%c info: Method=signOut: Start', mc.LOG_TYPE_I) : (() => { })()
      const myAuth = new MyAuth()
      myAuth.signOut()
      this.username = ''
      this.idToken = ''
      this.$router.push('/auth/signin')
      mc.LOG_LEVEL ? console.log('%c info: Method=signOut: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * checkSession
     *   認証セッションの状態をチェック
     * ============================================================================== */
    async checkSession () {
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: Start', mc.LOG_TYPE_I) : (() => { })()
      try {
        const myAuth = new MyAuth()
        const res = await myAuth.checkSession()
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: OK', mc.LOG_TYPE_I) : (() => { })()
          this.idToken = res.content.idToken
          this.username = res.content.username
        } else if (res.status === 'NOAUTH') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: NOAUTH', mc.LOG_TYPE_I) : (() => { })()
          this.WriteProcMsg('normal', res.content)
          setTimeout(() => { this.$router.push('/auth/signin') }, mc.MSG_TIMEOUT)
        }
      // モジュールmyAuth(promise)からのrejectや例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=checkSession: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to check session at the moment, try back later.')
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * readTagData
     *  タグデータを取得して表示
     * ============================================================================== */
    async readTagData () {
      mc.LOG_LEVEL ? console.log('%c info: Method=readTagData: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      this.onTagDataLoading = true
      try {
        // 認証セッションの状態をチェック
        await this.checkSession()
        if (!this.idToken) { this.onTagDataLoading = false; return false }
        const myData = new MyData()
        const res = await myData.readTagData(this.idToken)
        if (res.status === 'OK') {
          this.localTagData = res.content.data.Items
          this.localTagData.forEach(function (item) {
            item.onUpdate = false
            item.onDelete = false
            item.updateValTag = ''
          }, this)
          this.onUpdateDelete = false
        } else if (res.status === 'NODATA') {
          this.WriteProcMsg('normal', 'No data.')
        }
      // モジュールmyData(async)からの例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=readTagData: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to get the data at the moment, try back later.')
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=readTagData: End', mc.LOG_TYPE_I) : (() => { })()
      this.onTagDataLoading = false
    },

    /* =================================================================================
     * sortBy
     *   各カラムの昇順・降順を切替
     * ============================================================================== */
    sortBy (key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc
      } else {
        this.sortAsc = true
      }
      this.sortKey = key
    },

    /* =================================================================================
     * sortArrow
     *   各カラムの昇順・降順を示すフォントの表を切替
     * ============================================================================== */
    sortArrow (key) {
      let _sortArrow
      if (this.sortKey === key) {
        if (this.sortAsc) {
          _sortArrow = 'asc'
        } else {
          _sortArrow = 'desc'
        }
      } else {
        _sortArrow = ''
      }
      return _sortArrow
    },

    /* =================================================================================
     * deleteTagDataStart
     *   タグデータ削除仕掛かり中を示すフラグを立てる
     * ============================================================================== */
    deleteTagDataStart (targetItem) {
      const targetIndex = this.localTagData.indexOf(targetItem)
      this.localTagData[targetIndex].onDelete = true
      this.onUpdateDelete = true
    },

    /* =================================================================================
     * deleteTagDataCancel
     *   タグデータ削除仕掛かり中を示すフラグを下す
     * ============================================================================== */
    deleteTagDataCancel (targetItem) {
      const targetIndex = this.localTagData.indexOf(targetItem)
      this.localTagData[targetIndex].onDelete = false
      this.onUpdateDelete = false
      // タグ一覧取得を実行
      this.readTagData()
    },

    /* =================================================================================
     * deleteTagDataFix
     *   タグデータ削除を実行する
     * ============================================================================== */
    async deleteTagDataFix (targetItem) {
      mc.LOG_LEVEL ? console.log('%c info: Method=deleteTagDataFix: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      try {
        // 認証セッションの状態をチェック
        await this.checkSession()
        if (!this.idToken) { return false }
        const targetIndex = this.localTagData.indexOf(targetItem)
        const targetTag = this.localTagData[targetIndex].valTag
        const itemForDelete = { valTag: targetTag }
        const myData = new MyData()
        const res = await myData.deleteTagData(this.idToken, itemForDelete)
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=deleteTagDataFix: OK', mc.LOG_TYPE_I) : (() => { })()
          // タグ一覧取得を実行
          this.readTagData()
        }
      // モジュールmyData(async)からの例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=deleteTagDataFix: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to delete the data at the moment, try back later.')
      }
    },

    /* =================================================================================
     * updateTagDataStart
     *   タグデータ更新仕掛かり中を示すフラグを立てる
     * ============================================================================== */
    updateTagDataStart (targetItem) {
      const targetIndex = this.localTagData.indexOf(targetItem)
      this.localTagData[targetIndex].updateValTag = this.localTagData[targetIndex].valTag
      this.localTagData[targetIndex].onUpdate = true
      this.onUpdateDelete = true
    },

    /* =================================================================================
     * updateTagDataCancel
     *   タグデータ更新の仕掛かり中を示すフラグを下す
     * ============================================================================== */
    updateTagDataCancel (targetItem) {
      const targetIndex = this.localTagData.indexOf(targetItem)
      this.onUpdateDelete = false
      this.localTagData[targetIndex].onUpdate = false
      this.localTagData[targetIndex].updateValTag = ''
      // タグ一覧取得を実行
      this.readTagData()
    },

    /* =================================================================================
     * updateTagDataFix
     *   タグデータ更新を実行する
     * ============================================================================== */
    async updateTagDataFix (targetItem) {
      mc.LOG_LEVEL ? console.log('%c info: Method=updateTagDataFix: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      const targetIndex = this.localTagData.indexOf(targetItem)
      if (this.localTagData[targetIndex].updateValTag === '') {
        return false
      }
      try {
        // 認証セッションの状態をチェック
        await this.checkSession()
        if (!this.idToken) { return false }
        const targetTag = this.localTagData[targetIndex].valTag
        const targetNewTag = this.localTagData[targetIndex].updateValTag
        const itemForUpdate = { valTag: targetTag, valNewTag: targetNewTag }
        const myData = new MyData()
        const res = await myData.updateTagData(this.idToken, itemForUpdate)
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=updateTagDataFix: OK', mc.LOG_TYPE_I) : (() => { })()
          // タグ一覧取得を実行
          this.readTagData()
        }
      // モジュールmyData(async)からの例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=updateTagDataFix: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to update the data at the moment, try back later.')
      }
    },

    /* =================================================================================
     * WriteProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    WriteProcMsg (type, content) {
      if (type === 'normal') {
        this.procMsgNormal = content
        setTimeout(() => { this.procMsgNormal = null }, mc.MSG_TIMEOUT)
      } else if (type === 'attention') {
        this.procMsgAttention = content
        setTimeout(() => { this.procMsgAttention = null }, mc.MSG_TIMEOUT)
      }
    },

    /* =================================================================================
     * resetProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    resetProcMsg () {
      this.procMsgNormal = null
      this.procMsgAttention = null
    }
  },

  computed: {
    /* =================================================================================
     * localTagDataArranged
     *   タグデータをフィルタ・ソートした結果を返す
     * ============================================================================== */
    localTagDataArranged () {
      const filterWordLc = this.filterWord && this.filterWord.toLocaleLowerCase()
      let _localTagDataArranged
      if (filterWordLc) {
        _localTagDataArranged = this.localTagData.filter(record => {
          return record.valTag.toLocaleLowerCase().indexOf(filterWordLc) !== -1
        })
      } else {
        _localTagDataArranged = this.localTagData
      }
      if (this.sortKey !== '') {
        let set = 1
        if (this.sortAsc) {
          set = 1
        } else {
          set = -1
        }
        _localTagDataArranged.sort(
          (a, b) => {
            if (a[this.sortKey] < b[this.sortKey]) return -1 * set
            if (a[this.sortKey] > b[this.sortKey]) return 1 * set
            return 0
          }
        )
        return _localTagDataArranged
      } else {
        return _localTagDataArranged
      }
    }
  }
}
</script>

<style scoped lang="scss">
$BASE_COLOR: #055555;
$ACTIVE_COLOR: #08a702;
$FILTERBOX_BG_INACTIVE_COLOR: #e8e8e8;
$FILTERBOX_BG_ACTIVE_COLOR: #e4e4e136;
$FILTERBOX_BORDER_INACTIVE_COLOR: #055555;
$FILTERBOX_BORDER_ACTIVE_COLOR: #08a702;
$PLACEHOLDER_COLOR: #05555554;
$TABLE_ROW_PRIME_BG_COLOR: #ebebeb;
$TABLE_ROW_PRIME_BORDER_COLOR: #055555;
$TABLE_ROW_SUB_BG_COLOR: #e4e4e136;
$TABLE_ROW_SUB_BORDER_COLOR: #05555554;

.div-session {
  text-align: right;
}
.fa-sign-out-alt {
  cursor: pointer;
}
.div-filter {
  text-align: right;
  position: sticky;
  top: 0;
  background-color: #fff;
}
.div-filter-bar {
  height: 2.5em;
  max-width: 22em;
  margin-top: 0.75em;
  margin-bottom: 0.5em;
  margin-left: auto;
  border: 1.5px solid #fff;
  border-bottom: 2.5px solid $FILTERBOX_BORDER_INACTIVE_COLOR;
  outline: none;
  background-color: $FILTERBOX_BG_INACTIVE_COLOR;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.div-filter-bar:focus-within {
  border: 1.5px solid $FILTERBOX_BORDER_ACTIVE_COLOR;
  border-bottom: 2.5px solid $FILTERBOX_BORDER_ACTIVE_COLOR;
  background-color: $FILTERBOX_BG_ACTIVE_COLOR;
}
.fa-filter {
  padding: 0.1em 0.1em;
  font-size: 1.2em;
  color: $BASE_COLOR;
}
.fa-times {
  padding: 0.1em 0.1em;
  font-size: 1.5em;
  color: $BASE_COLOR;
  display: inline;
  cursor: pointer;
}
.div-filter-bar input {
  width: 100%;
  border: none;
  font-size: 1em;
  background-color: transparent;
  outline: none;
}
.div-filter-bar input::placeholder {
  color: $PLACEHOLDER_COLOR;
}
.table-list {
  width: 100%;
}
.table-list .colgroup-col01 {
  width: 80%;
}
.table-list .colgroup-col02 {
  width: 20%;
}
.table-list th,
.table-list td {
  padding: 0.25em 0.5em;
}
.table-list th {
  text-align: center;
  font-weight: normal;
  color: #fff;
  background: $BASE_COLOR;
  position: sticky;
  top: 2.55em;
  line-height: 1.25em;
}
.div-th-col {
  display:inline-block;
  cursor: pointer;
}
.div-action-reload {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.div-action {
  padding: 0 0.3em 0 0;
}
.div-reload {
  padding: 0 0 0 0.3em;
  display:inline-block;
  cursor: pointer;
}
.fa-redo {
  color: #fff;
  font-size:1.2em;
}
.fa-redo:active {
  color: $ACTIVE_COLOR;
  font-size:1.2em;
}
.tr-body:hover td {
  background: $TABLE_ROW_SUB_BG_COLOR;
}
.table-list td {
  line-height: 1.5em;
  border-bottom: 1px dashed $TABLE_ROW_SUB_BORDER_COLOR;
  vertical-align: top;
}
.table-list td.td-prime-col,
.table-list td.td-sub-col:not(:last-child) {
  text-align: left;
}
.table-list td.td-sub-col:last-child {
  text-align: center;
  width: auto;
}
.div-prime-col {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.label-prime-col {
  cursor: pointer;
}
.tr-head-onShrink {
  display: none;
}
/* ↓ spinner ↓ */
.div-container-sipnner{
  display: flex;
  justify-content: center;
}
.div-spinner {
  z-index: 49;
  font-size: 10px;
  text-indent: -9999em;
  margin-top:5em;
  width: 11em;
  height: 11em;
  border-radius: 50%;
  background: #3a7c0e;
  background: -moz-linear-gradient(left, #3a7c0e 10%, rgba(58,124,14, 0) 42%);
  background: -webkit-linear-gradient(left, #3a7c0e 10%, rgba(58,124,14, 0) 42%);
  background: -o-linear-gradient(left, #3a7c0e 10%, rgba(58,124,14, 0) 42%);
  background: -ms-linear-gradient(left, #3a7c0e 10%, rgba(58,124,14, 0) 42%);
  background: linear-gradient(to right, #3a7c0e 10%, rgba(58,124,14, 0) 42%);
  position: absolute;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.div-spinner:before {
  width: 50%;
  height: 50%;
  background: #3a7c0e;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
}
.div-spinner:after {
  background: #f1f4f4;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
/* ↑ spinner ↑ */

@media screen and (max-width: 559px) {
  .div-filter {
    position: static;
    /*
    position: sticky  -webkit-sticky;
    top: 0;
    */
  }
  .div-filter-bar {
    max-width: 100%;
  }
  .table-list .colgroup-col01,
  .table-list .colgroup-col02 {
    width: 100%;
  }
  .tr-head {
    display: none;
  }
  .tr-head-onShrink {
    display: block;
    padding: 0;
    /*
    position: sticky -webkit-sticky;
    top: 0em;
    */
  }
  .tr-head-onShrink td {
    line-height: 2em;
  }
  .table-list td.td-cols-action-reload {
    width: 100%;
    text-align: center;
    font-weight: normal;
    color: #fff;
    background: $BASE_COLOR;
    padding: 0;
  }
  .div-cols-action-reload {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }
  .div-cols-action {
    padding: 0 0.25em;
    color: #fff;
  }
  .div-cols-reload {
    padding: 0 0.25em;
    color: #fff;
    display:inline-block;
    cursor: pointer;
  }
  .fa-redo {
    color: #fff;
    font-size:large;
  }
  .fa-redo:active {
    color: $ACTIVE_COLOR;
    font-size:large;
  }
  .table-list td {
    display: block;
  }
  .table-list td::before {
    content: attr(td-sub-col);
    display: block;
  }
  .td-prime-col {
    border-top: 2px solid $TABLE_ROW_PRIME_BORDER_COLOR;
    background: $TABLE_ROW_PRIME_BG_COLOR;
    width: 100%;
  }
  .tr-body:hover .td-prime-col {
    background: $TABLE_ROW_PRIME_BG_COLOR;
  }
  .table-list td.td-prime-col,
  .table-list td.td-sub-col:not(:last-child) {
    text-align: center;
    width: initial;
  }
}
</style>
